<template>
  <!-- Alert Toast -->
  <div
    class="bottom-alert"
    :class="{
      visible: !!toastMsg,
    }">
    <div
      class="alert alert-secondary"
      role="alert">
      {{toastMsg}}
    </div>
  </div>
  <!-- / Alert Toast -->
</template>

<script>
export default {
  name: 'toast',
  data() {
    return {
      toastMsg: '',
    };
  },
  created() {
    this.$root.$on('show-toast', (data) => {
      this.toastMsg = data.msg;
    });

    this.$root.$on('hide-toast', () => {
      this.toastMsg = '';
    });
  },
};
</script>

<style lang="scss">
.bottom-alert {
  position: fixed;
  z-index: 999999;
  bottom: 0;
  left: 1rem;
  width: calc(100% - 2rem);

  transform: translateY(50px);
  opacity: 0;
  transition-property: transform, opacity;
  transition-duration: 0.5s;

  &.visible {
    transform: translateY(0);
    opacity: 1;
  }

  .alert {
    height: 50px;
  }
}
</style>
